"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnyCookieNotificationEnabledValue = exports.getAnyCookiesEnabledValue = exports.getRequireCookieOptInValue = exports.getCookieNotificationEnabledValue = exports.getCookiePolicyOverrides = exports.getCookieNotificationConfigurations = exports.getCookiesEnabledValue = exports.getPrivacyPolicyValue = exports.getShouldShowConsentForm = exports.getChangedSettings = exports.getStagedSettings = exports.getSettings = exports.getPrivacyPolicyOptions = void 0;

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _reselect = require("reselect");

var _getModuleState = _interopRequireDefault(require("./getModuleState"));

var _PrivacyPolicyTypes = _interopRequireDefault(require("../constants/PrivacyPolicyTypes"));

var _CookieNotificationSettings = _interopRequireDefault(require("../records/CookieNotificationSettings"));

var getPrivacyPolicyOptions = function getPrivacyPolicyOptions() {
  return [{
    value: _PrivacyPolicyTypes.default.NO_REQUEST,
    text: _I18n.default.text('analyticsAndTracking.privacy.types.noRequest')
  }, {
    value: _PrivacyPolicyTypes.default.NOTIFY,
    text: _I18n.default.text('analyticsAndTracking.privacy.types.notify')
  }, {
    value: _PrivacyPolicyTypes.default.REQUEST_CONSENT,
    text: _I18n.default.text('analyticsAndTracking.privacy.types.requestConsent')
  }, {
    value: _PrivacyPolicyTypes.default.NO_COOKIES,
    text: _I18n.default.text('analyticsAndTracking.privacy.types.noCookies')
  }];
};

exports.getPrivacyPolicyOptions = getPrivacyPolicyOptions;
var getSettings = (0, _reselect.createSelector)([_getModuleState.default], function (state) {
  return state.settings.get('settings');
});
exports.getSettings = getSettings;
var getStagedSettings = (0, _reselect.createSelector)([_getModuleState.default], function (state) {
  return state.settings.get('staged');
});
exports.getStagedSettings = getStagedSettings;
var getChangedSettings = (0, _reselect.createSelector)([getSettings, getStagedSettings], function (settings, staged) {
  return staged.keySeq().filter(function (settingKey) {
    return staged.get(settingKey) !== settings.get(settingKey);
  }).toList();
});
exports.getChangedSettings = getChangedSettings;
var getShouldShowConsentForm = (0, _reselect.createSelector)([getStagedSettings], function (settings) {
  return settings.privacyPolicy === _PrivacyPolicyTypes.default.REQUEST_CONSENT;
});
exports.getShouldShowConsentForm = getShouldShowConsentForm;
var getPrivacyPolicyValue = (0, _reselect.createSelector)([getStagedSettings], function (settings) {
  return settings.get('privacyPolicy') === _PrivacyPolicyTypes.default.REQUEST_CONSENT && settings.get('privacyHideDecline') ? _PrivacyPolicyTypes.default.NOTIFY : settings.get('privacyPolicy');
});
exports.getPrivacyPolicyValue = getPrivacyPolicyValue;
var getCookiesEnabledValue = (0, _reselect.createSelector)([getStagedSettings], function (settings) {
  return settings.privacyPolicy !== _PrivacyPolicyTypes.default.NO_COOKIES;
});
exports.getCookiesEnabledValue = getCookiesEnabledValue;
var getCookieNotificationConfigurations = (0, _reselect.createSelector)([getStagedSettings], function (settings) {
  return (0, _immutable.List)(settings.get('policyOverrides', [])).map(_CookieNotificationSettings.default.buildOverride).unshift(_CookieNotificationSettings.default.buildDefault(settings));
});
exports.getCookieNotificationConfigurations = getCookieNotificationConfigurations;
var getCookiePolicyOverrides = (0, _reselect.createSelector)([getStagedSettings], function (settings) {
  return (0, _immutable.List)(settings.policyOverrides || []).map(_CookieNotificationSettings.default.buildOverride);
});
exports.getCookiePolicyOverrides = getCookiePolicyOverrides;
var getCookieNotificationEnabledValue = (0, _reselect.createSelector)([getStagedSettings], function (settings) {
  return settings.get('privacyPolicy') === _PrivacyPolicyTypes.default.REQUEST_CONSENT;
});
exports.getCookieNotificationEnabledValue = getCookieNotificationEnabledValue;
var getRequireCookieOptInValue = (0, _reselect.createSelector)([getStagedSettings], function (settings) {
  return settings.get('privacyPolicy') === _PrivacyPolicyTypes.default.REQUEST_CONSENT && !settings.get('privacyHideDecline');
});
exports.getRequireCookieOptInValue = getRequireCookieOptInValue;
var getAnyCookiesEnabledValue = (0, _reselect.createSelector)([getCookieNotificationConfigurations], function (configurations) {
  return configurations.some(function (config) {
    return config.privacyPolicy !== _PrivacyPolicyTypes.default.NO_COOKIES;
  });
});
exports.getAnyCookiesEnabledValue = getAnyCookiesEnabledValue;
var getAnyCookieNotificationEnabledValue = (0, _reselect.createSelector)([getCookieNotificationConfigurations], function (configurations) {
  return configurations.some(function (config) {
    return config.privacyPolicy === _PrivacyPolicyTypes.default.REQUEST_CONSENT || config.privacyPolicy === _PrivacyPolicyTypes.default.NOTIFY;
  });
});
exports.getAnyCookieNotificationEnabledValue = getAnyCookieNotificationEnabledValue;